import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { TPack } from '../entities/packs.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PacksService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getPack(id: string): Observable<TPack> {
    return this.http.get<TPack>(`${this.apiUrl.subscription_service}/Pack`, {
      params: {
        id
      },
      withCredentials: true,
    });
  }

  public createPack(payload: TPack): Observable<TPack> {
    return this.http.post(`${this.apiUrl.subscription_service}/Pack`, payload, {
      withCredentials: true,
    });
  }

  public updatePack(payload: TPack): Observable<TPack> {
    return this.http.put(`${this.apiUrl.subscription_service}/Pack`, payload, {
      withCredentials: true,
    });
  }

  public deletePack(id: string): Observable<TPack> {
    return this.http.delete(`${this.apiUrl.subscription_service}/Pack`, {
      withCredentials: true,
      params: {
        id
      },
    });
  }

  public getPacks(
    page: number,
    query?: string
  ): Observable<{ "@odata.context": string; "@odata.count"?: number; value: TPack[] }> {
    const top = 6;
    const skip = top * (page - 1);

    const params: Record<string, string | number | boolean> = {
      $skip: skip,
      $top: top,
      $count: true,
      $expand: 'Resources($expand=Product,ResourcesRanges)'
    };
    const filters: string[] = [];
    filters.push(`(IsActive eq true)`);

    if (query) {
      filters.push(`contains(tolower(Name),'${query}')`);
    }

    if (filters.length) {
      params['$filter'] = filters.join(' and ');
    }

    return this.http.get<{ "@odata.context": string; "@odata.count"?: number; value: TPack[] }>(
      `${this.apiUrl.odata_subscription_service}/Packs`,
      {
        params,
        withCredentials: true
      }
    );
  }

}
